"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var transitions_1 = __importDefault(require("./utils/transitions"));
var ToastElement = function (_a) {
    var appearance = _a.appearance, placement = _a.placement, transitionDuration = _a.transitionDuration, transitionState = _a.transitionState, props = __rest(_a, ["appearance", "placement", "transitionDuration", "transitionState"]);
    var _b = react_1.useState("auto"), height = _b[0], setHeight = _b[1];
    var elementRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (transitionState === "entered") {
            var el = elementRef.current;
            setHeight(el.offsetHeight + 8);
        }
        if (transitionState === "exiting") {
            setHeight(0);
        }
    }, [transitionState]);
    return (react_1["default"].createElement("div", { ref: elementRef, style: {
            height: height,
            transition: "height " + (transitionDuration - 100) + "ms 100ms"
        } },
        react_1["default"].createElement("div", __assign({ className: "react-toast-notifications__toast react-toast-notifications__toast--" + appearance, style: __assign({ transition: "transform " + transitionDuration + "ms cubic-bezier(0.2, 0, 0, 1), opacity " + transitionDuration + "ms" }, transitions_1["default"](placement)[transitionState]) }, props))));
};
exports["default"] = ToastElement;
